"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLinkIcon(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M15.038 8.932c.1.101.213.229.339.383l.384.494.528.72a.766.766 0 11-1.238.902l-.619-.84-.192-.245a4.527 4.527 0 00-.288-.333 4.518 4.518 0 00-6.238-.16l-.169.16-4.684 4.688a4.56 4.56 0 000 6.436 4.52 4.52 0 006.235.166l.168-.16 2.491-2.549a.766.766 0 011.169.984l-.073.087-2.497 2.554a6.053 6.053 0 01-8.578 0 6.092 6.092 0 01-.181-8.41l.182-.19 4.684-4.687a6.05 6.05 0 018.577 0zm7.137-7.15a6.092 6.092 0 01.182 8.41l-.182.19-4.684 4.687a6.033 6.033 0 01-3.93 1.771l-.24.01h-.238a6.037 6.037 0 01-4.17-1.781 6.5 6.5 0 01-.47-.547l-.252-.33-.529-.72a.766.766 0 01.578-1.216l.108.002a.764.764 0 01.553.312l.618.84.192.245c.119.147.217.26.288.333a4.509 4.509 0 003.204 1.331l.217-.005a4.506 4.506 0 002.817-1.166l.17-.16L21.09 9.3a4.56 4.56 0 000-6.436 4.51 4.51 0 00-3.203-1.333l-.218.005a4.498 4.498 0 00-2.814 1.162l-.169.16-2.49 2.549a.763.763 0 01-.486.228l-.107.001a.766.766 0 01-.576-1.213l.073-.087 2.496-2.554a6.052 6.052 0 018.578 0z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgLinkIcon;
exports.default = _default;